/* eslint react/no-array-index-key: 0  */
import React from 'react';
import _ from 'lodash';
import { formatDateWithHour } from 'src/utils/Date';
import { NEW_LINE_CHARACTERS } from 'src/constants/Generals';
import styles from './JobStatus.scss';
import { useTranslation } from 'react-i18next';

const JobSuccess = ({ statusText, jobInfo, startAt, endAt, canNotSyncEmployees, canNotSyncAllowances }) => {
  const { t } = useTranslation();
  return (
    <li>
      <p className={styles.title}>
        {jobInfo}
        <br />
        {statusText}
      </p>
      <div className={styles.dates}>
        <dl>
          <dt>{t('components.JobStatus.AllJobStatus.executed_date')}：</dt>
          <dd>{formatDateWithHour(startAt)}</dd>
        </dl>
        <dl>
          <dt>{t('components.JobStatus.AllJobStatus.completed_date')}：</dt>
          <dd>{formatDateWithHour(endAt)}</dd>
        </dl>
      </div>
      {!_.isEmpty(canNotSyncEmployees) && (
        <div className={styles.canNotSyncEmployee}>
          <p>
            {t('components.JobStatus.JobSuccess.Attendance_information_could_not_be_obtained_for_the_following_users')}<br />
          </p>
          <p>
            {t('components.JobStatus.JobSuccess.Make_sure_that_the_Staff_Code_Last_Name_and_First_Name_registered_in_JOBCAN_Attendance_and_Payroll_match')}<br />
          </p>
          <p>
            {t('components.JobStatus.JobSuccess.If_you_do_not_want_to_link_with_JOBCAN_Attendance_please_uncheck_the_checkbox_of_the_target_person_in_Link_with_JOBCAN_Attendance_Employee_Attendance_Link_Settings')}<br />
          </p>
          <ul>{canNotSyncEmployees.split(NEW_LINE_CHARACTERS).map((employee, idx) => <li key={idx}>{employee}</li>)}</ul>
        </div>
      )}
      {!_.isEmpty(canNotSyncAllowances) && (
        <div className={styles.canNotSyncEmployee}>
          <p>
            {t('components.JobStatus.JobSuccess.Attendance_information_could_not_be_obtained_for_the_following_items')}
            <br />
          </p>
          <ul>{canNotSyncAllowances.split(NEW_LINE_CHARACTERS).map((allowance, idx) => <li key={idx}>{allowance}</li>)}</ul>
        </div>
      )}
    </li>
  );
};

export default JobSuccess;
